export default __webpack_public_path__ + "static/Row 3.3_ahmadibrahimsec-da57a66557d8cf35d4b66f6d8f09a660.jpg";